
import { useState } from "react";
import { cn } from "@/lib/utils";

type MoodSelectorProps = {
  value: number;
  onChange: (value: number) => void;
  className?: string;
};

const MoodSelector = ({ value, onChange, className }: MoodSelectorProps) => {
  // Define mood data for rendering
  const moods = [
    { value: 1, label: "Struggling", emoji: "😣", color: "bg-red-100 border-red-200 text-red-600" },
    { value: 2, label: "Low", emoji: "😔", color: "bg-amber-100 border-amber-200 text-amber-600" },
    { value: 3, label: "Okay", emoji: "😐", color: "bg-blue-100 border-blue-200 text-blue-600" },
    { value: 4, label: "Good", emoji: "🙂", color: "bg-emerald-100 border-emerald-200 text-emerald-600" },
    { value: 5, label: "Great", emoji: "😄", color: "bg-green-100 border-green-200 text-green-600" },
  ];

  const handleSelect = (moodValue: number) => {
    onChange(moodValue);
  };

  return (
    <div className={cn("flex flex-wrap gap-3 justify-center md:justify-start", className)}>
      {moods.map((mood) => (
        <button
          key={mood.value}
          onClick={() => handleSelect(mood.value)}
          className={cn(
            "flex flex-col items-center p-3 rounded-lg border-2 transition-all",
            mood.color,
            value === mood.value
              ? "ring-2 ring-primary/50 border-primary/50 scale-105"
              : "hover:scale-105 opacity-80 hover:opacity-100"
          )}
        >
          <span className="text-2xl mb-1">{mood.emoji}</span>
          <span className="text-sm font-medium">{mood.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MoodSelector;
